<script>
/* eslint-disabled */
import { mapGetters } from "vuex"

export default {
    props: ['item', 'circuit', 'parentItem'],
    data(){
        return {
            changed: false,
            editMode: false,
            name: this.item ? this.item.name : '',
            notes: this.item ? this.item.notes : '',
            reps: this.item ? this.item.reps : ''
        }
    },
    watch: {
        name(){
            this.changed = true
        },
        notes(){
            this.changed = true
        },
        item(val){
            this.name = val.name
            this.notes = val.notes
        },
    },
    methods: {
        save(){
            this.$store.dispatch('scripts/updateItem', {
                name: this.name,
                notes: this.notes,
                title: this.name,
                instruction: this.notes,
                confirmed: true,
                id: this.item.id,
                reps: this.reps,
                type: 'move'
            })
            this.$store.dispatch('scripts/updateMove', {
                name: this.name,
                notes: this.notes,
                title: this.name,
                instruction: this.notes,
                confirmed: true,
                id: this.item.id,
                reps: this.reps,
                type: 'move'
            })
            this.$store.commit('scripts/clearSelectedMoves')
           

            setTimeout(() => { 
                this.$store.dispatch(
                `${this.currentType}/getActivity`,
                    this.$route.params.id
                );
                setTimeout(() => {  this.$store.commit(`${this.currentType}/setTabStatus`, false);}, 1000);                
            }, 2000);

            
        },
        cancel(){
            if (!this.editMode) {
                this.$store.dispatch('scripts/removeItem', this.item.id)
                this.$store.dispatch('scripts/removeMove', this.item.id)
                return
            }
            this.$store.dispatch('scripts/removeItem', this.item.id)
            this.$store.dispatch('scripts/removeMove', this.item.id)
            this.editMode = false
            this.$store.dispatch('scripts/updateItemNoSync', {
                confirmed: true,
                id: this.item.id,
            })
        },
        edit(){
            this.$store.dispatch('scripts/updateItemNoSync', {
                confirmed: false,
                id: this.item.id,
            })
            this.changed = true
            this.editMode = true
        },
        deleteItem(){
            this.$store.dispatch('scripts/removeItem', this.item.id)
            this.$store.dispatch('scripts/removeMove', this.item.id)
        }
    },
    computed: {
        ...mapGetters({
            sortedMove: "scripts/sortedMove",
            selectedMoves: "scripts/selectedMoves",
            itemOrdering: "scripts/itemOrdering"
        }),
        order(){
            const sortedMove = this.sortedMove.find(move => move.id === this.item.id)
            if (sortedMove) {
                return sortedMove.order
            }
            return 0
        },
        alternateColor() {
            return this.order % 2 == 0
        },
        selected: {
            set(val) {
                if (val) {
                    this.$store.commit('scripts/pushSelectedMoves', this.item.id)
                }
                else {
                    this.$store.commit('scripts/popSelectedMoves', this.item.id)
                }
            },
            get() {
                return this.selectedMoves.includes(this.item.id)
            }
        },
        currentType() {
            const url = this.$route.path.split("/")[1];
            if (this.$route) {
                if (url == "update-warmup" || this.$route.path == "/create-warmup") {
                return "warmups";
                } else if (
                url == "update-stretch-flow" ||
                this.$route.path == "/create-stretch-flow"
                ) {
                return "stretchflows";
                } else if (
                url == "update-workout" ||
                this.$route.path == "/create-workout"
                ) {
                return "workouts";
                }
            }
            return "commons";
        },
        
        coloursOptions() {
        return this.$store.getters[`${this.currentType}/coloursOptions`];
        },
        currentActivity() {
            return this.$store.getters[`${this.currentType}/currentActivity`];
        },
        activeColour() {
        return this.coloursOptions && this.currentActivity.colour
            ? this.coloursOptions.find(
                (option) => option.id == this.currentActivity.colour
            )
            : {
                value: "#469a2e",
            };
        },
    }
}
</script>


<style scoped>
    .selector{
        border-right: 5px solid #707070;
       padding-top: 8px;
       padding-bottom: 8px;
    }
    .selector .round input[type=checkbox]{
        height: 0;
    }
    .row{
        min-height: 40px;
        margin:-1px 0 0 0;
    }
    .label{
        text-align: right;
        text-transform: uppercase;
    }
    .input-container{
       background-color: #effdff;
    }
    .input-container .group, .input-container .selector{
       padding-top: 8px;
       padding-bottom: 8px;
    }
    .btn-action-group{
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .btn-action-group .btn-action{
        text-transform: uppercase;
        margin-right: 1rem;
        padding: 0.75rem;
    }
    .script-item{
        font-family: 'Times New Roman', Times, serif;
        display: block;
    }
    .script-item.move-block{
        font-size: 24px;
        color: #000;
        font-weight: bold;
    }
    .script-item.move-block.alt{
        color: #34B362;
    }
    .script-item.note-block{
        font-size: 18px;
        color: #F2711C;
    }
    .count{
        margin-right: 1.5rem;
    }   
    .reps-count-mark{
        font-size: 24px;
        font-family: 'Times New Roman', Times, serif;
        font-weight: 600;
    } 
    .label-with-reps{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .reps-box{
        margin-left: 2rem;
    }
    .reps-wrap{
        text-align: right;
    }
    button.icon-only{
        border: 0;
        background-color: transparent;
    }
    .details-wrapper{
        padding-top: 10px;
        padding-bottom: 8px;
    }
    .round-list .details-wrapper > .d-flex{
        width: 75%;
    }
</style>
<template>
    <div class="row move" v-if="!item || item.type === 'filler'">
        <div class="selector col-md-1">
        </div>
        <div class="col-md-11">
        </div>
    </div>
    <div class="row input-container" v-else-if="item && !item.confirmed">
        <div class="selector col-md-1">
        </div>
        <div class="col-md-8 group">
            <div class="row">
                <div class="col-md-2 label pt-1"><label>Move Name</label></div>
                <div :class="circuit.type === 'reps' ? 'col-md-8' : 'col-md-10'"><b-form-input v-model="name" placeholder="Eg.: R/L SQUAT KICK" :id="'move-'+item.id"></b-form-input></div>
                <div class="col-md-2 label-with-reps" v-if="circuit.type === 'reps'"><label class="reps-count-mark">X</label><b-form-input v-model="reps" class="reps-box"></b-form-input></div>
            </div>
            <div class="row">
                <div class="col-md-2 label pt-1"><label>Notes</label></div>
                <div class="col-md-10"><b-form-input v-model="notes" placeholder="Optional"></b-form-input></div>
            </div>
        </div>
        <div class="col-md-3 btn-action-group">
            <div>
                <b-button size="sm" class="btn-action cancel" @click="cancel()">Cancel</b-button>
                <b-button size="sm" class="btn-action" variant="primary" :disabled="!changed" @click="save()">Save</b-button>
            </div>
        </div>
    </div>
    <div class="row draggable" :class="selected ? 'input-container' : ''" v-else>
        <div class="selector col-md-1">
           <div class="round" v-if="parentItem">
                <input type="checkbox" :id="'checkbox'+item.id" v-model="selected"/>
                <label :for="'checkbox'+item.id"></label>
          </div>
        </div>
        <div class="col-md-11 details-wrapper">
            <div class="d-flex ">
                <div class="d-flex align-items-start">
                    <div class="float-left count">
                        <span class="move-block script-item">{{order}}.</span>
                    </div>
                    <div class="float-left">
                        <span class="move-block script-item" 
                        :style="{ color: alternateColor && activeColour ? activeColour.value : '' }"
                        :class="alternateColor ? 'alt' : ''"> {{item ? item.name : ''}}</span>
                        <span class="note-block script-item">{{item ? item.notes : ''}}</span>
                    </div>
                </div>
                <div class=" label-with-reps" v-if="circuit.type === 'reps'">
                    <div class="row">
                        <div class="col-md-2 reps-wrap">
                            <label class="reps-count-mark">X</label>
                        </div>
                        <div class="col-md-6">
                            <b-form-input v-model="reps" readonly="readonly"></b-form-input>
                        </div>
                    </div>
                </div>
                <div class="label-with-reps pl-2" v-if="selected">
                    <button class="icon-only" @click="edit()">
                        <b-icon icon="pencil" font-scale="1.5"></b-icon>
                    </button>
                    <button class="icon-only pl-2" @click="deleteItem()">
                        <b-icon icon="trash" variant="danger" font-scale="1.5"></b-icon>
                    </button>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-md-11 col-sm-7">
                    <div class="float-left count">
                        <span class="move-block script-item">{{order}}.</span>
                    </div>
                    <div class="float-left">
                        <span class="move-block script-item" :class="alternateColor ? 'alt' : ''"> {{item ? item.name : ''}}</span>
                        <span class="note-block script-item">{{item ? item.notes : ''}}</span>
                    </div>
                </div>
                <div class=" label-with-reps" v-if="circuit.type === 'reps'">
                    <div class="row">
                        <div class="col-md-2 reps-wrap">
                            <label class="reps-count-mark">X</label>
                        </div>
                        <div class="col-md-6">
                            <b-form-input v-model="reps" readonly="readonly"></b-form-input>
                        </div>
                    </div>
                </div>
                <div class="label-with-reps" v-if="selected">
                    <button class="icon-only" @click="edit()">
                        <b-icon icon="pencil" font-scale="1.5"></b-icon>
                    </button>
                    <button class="icon-only pl-3" @click="deleteItem()">
                        <b-icon icon="trash" variant="danger" font-scale="1.5"></b-icon>
                    </button>
                </div>
            </div> -->
        </div>
        
    </div>
</template>